import ReducerBuilder from "../classes/ReducerBuilder";
import initialState from "./initialState";
import {Types} from "./actions";
import * as SectionActions from "utils/sectionManagement/actions";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.OPEN_SECTION_SCROLL)
    .reduce((state, action) => {
        state.openSectionScrollDone = true;
    })
    .forType(SectionActions.Types.TOGGLE_SECTION_OPEN)
    .reduce((state, action) => {
        if (action.scrollTo) {
            state.scrollToSection = action.sectionKey;
        }
    })
    .forType(Types.TOGGLE_SECTION_SCROLL)
    .reduce((state, action) => {
        state.scrollToSection = null;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/scroll/reducer.js